module.exports = __webpack_public_path__ + "img/LoanRequestRe.498227b9.svg";